import { MODAL_HEIGHT, appConfig } from "@/constants";
import {
  Body,
  Box,
  BulletList,
  ConfirmationDialog,
  FramedImage,
  Link,
} from "@biom3/react";
import type { Content } from "@prismicio/client";
import { trackGameDetailsEvent } from "@ui-kit/utils";
import NextLink from "next/link";

type DarkMachineNFTModalProps = {
  onClose: () => void;
  game: Content.GameDocument;
};

export const DarkMachineNFTModal = ({
  onClose,
  game,
}: DarkMachineNFTModalProps) => (
  <ConfirmationDialog visible>
    <ConfirmationDialog.Content
      textAlign="left"
      sx={{
        h: MODAL_HEIGHT,
        maxWidth: { default: "100dvw", small: "430px", medium: "500px" },
        backgroundColor: "base.color.neutral.800",
      }}
    >
      <ConfirmationDialog.Content.CloseButtCon onClick={onClose} />
      <ConfirmationDialog.Content.Image
        imageUrl={`${appConfig.ASSET_BASE_URL}/images/games/darkmachine-banner.png`}
        aspectRatio={4}
        responsiveSizes={[370, 450, 512, 720, 1024]}
        sx={{ height: "161px" }}
      />

      <ConfirmationDialog.Content.Title
        size="small"
        sx={{
          marginBottom: "base.spacing.x4",
          position: "relative",
          pt: "base.spacing.x4",
          pr: "base.spacing.x4",
          pl: "base.spacing.x4",
        }}
      >
        <FramedImage
          emphasized={true}
          imageUrl={`${appConfig.ASSET_BASE_URL}/images/games/darkmachine-logo.png`}
          size="xLarge"
          sx={{
            position: "absolute",
            left: "0px",
            top: "-65px",
          }}
        />
        Discover if you won 1 out of 3 NFTs worth 0.25 ETH*
      </ConfirmationDialog.Content.Title>
      <ConfirmationDialog.Content.Caption>
        <Box sx={{ pl: "base.spacing.x4", pr: "base.spacing.x4" }}>
          <BulletList
            sx={{
              wordWrap: "break-word",
              "& > ul": { gap: "base.spacing.x1" },
            }}
          >
            <BulletList.Item>
              5800 Users told us why they were excited about Dark Machine by
              replying to{" "}
              <Link
                rc={
                  <a
                    href="https://x.com/Immutable/status/1879404771695833270"
                    target="_blank"
                    rel="noreferrer"
                  />
                }
              >
                this X post{" "}
              </Link>
            </BulletList.Item>
            <BulletList.Item>Best 3 replies won</BulletList.Item>
          </BulletList>
        </Box>
      </ConfirmationDialog.Content.Caption>
      <ConfirmationDialog.Content.Caption>
        <Box sx={{ pl: "base.spacing.x4" }}>
          <Body size="xSmall" sx={{ color: "base.color.text.body.secondary" }}>
            Competition ended on January 22nd, 2025. Winners were contacted from
            the @Immutable account on X. NFTs were distributed thereafter.
          </Body>
        </Box>
      </ConfirmationDialog.Content.Caption>
      <ConfirmationDialog.Content.Caption>
        <Box sx={{ pl: "base.spacing.x4" }}>
          <Body size="xSmall" sx={{ color: "base.color.text.body.secondary" }}>
            * Estimated value as at 15 Jan 2025, subject to market price
            changes.
          </Body>
        </Box>
      </ConfirmationDialog.Content.Caption>
      <ConfirmationDialog.Content.Button
        size="large"
        variant="primary"
        rc={
          <NextLink
            href={"https://x.com/Immutable/status/1879404771695833270"}
            referrerPolicy="no-referrer"
            target="_blank"
            onClick={() => {
              trackGameDetailsEvent({
                game,
                action: "Pressed",
                control: "Reply to Post",
                controlType: "Button",
                identifier: "bonus-variant-2",
                extras: {
                  link: "https://x.com/Immutable/status/1879404771695833270",
                  label: "Reply to Post",
                  gameId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c",
                },
              });
            }}
          />
        }
      >
        Reply to Post
      </ConfirmationDialog.Content.Button>
      <ConfirmationDialog.Content.Button
        size="large"
        variant="tertiary"
        onClick={onClose}
      >
        Not Now
      </ConfirmationDialog.Content.Button>
    </ConfirmationDialog.Content>
  </ConfirmationDialog>
);
